import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {fuseAnimations} from '@fuse/animations';
import {CategoryService} from "../../../services/category.service";
import {AlertService} from "../../../services";
import {Order} from "../../../models/order";

@Component({
    selector: 'pos-main-sidebar',
    templateUrl: './main-sidebar.component.html',
    styleUrls: ['./main-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class PosMainSidebarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    loadingIndicator: boolean;
    order: Order;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.loadingIndicator = true;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New order
     */
    newOrder(): void {
        this._router.navigate(['/pos']).then(() => {

        });
    }
}
